import {Dropdown, DropdownChangeEvent} from "primereact/dropdown";
import {Classes, Labeled} from "./Basics";
import {useState} from "react";

type Properties = Classes & Labeled & {
    val: KeyValuePropery
    options: Array<KeyValuePropery>
    onChange: (val: KeyValuePropery) => void
    disable?: boolean
}

export type KeyValuePropery = {
    key: string,
    value: string
}

function PredefinedKeyValueSetProperty(props: Properties) {

    function handleOnChange(ce: DropdownChangeEvent) {
        if (props.onChange != null) {
            props.onChange(props.options[keyIndex[ce.value]])
            ce.preventDefault()
        }
    }

    const keyIndex: any = {}

    props.options.forEach((value, index) =>
        keyIndex[value.key] = index
    )

    let selected = props.val?.key

    return <>
        <div className={"property-element"}>
            <label
                className={(props.labelAdditionalClassName == null ? "" : (" " + props.labelAdditionalClassName))}>
                {props.label}
            </label>
            <Dropdown
                className={"item" + (props.inputAdditionalClassName == null ? "" : (" " + props.inputAdditionalClassName))}
                value={selected}
                onChange={handleOnChange}
                options={props.options}
                optionLabel={"value"}
                optionValue={"key"}
                disabled={props.disable != undefined && props.disable}
            />
        </div>
    </>
}

export default PredefinedKeyValueSetProperty